export const GET_WITHDRAWAL = "GET_WITHDRAWAL";
export const UPDATE_WITHDRAWAL = "UPDATE_WITHDRAWAL";
export const GET_ADMINS = "GET_ADMINS";
